var map = {
	"./Login": 42,
	"./Login/": 42,
	"./Login/index": 42,
	"./Login/index.jsx": 42,
	"./Login/test": 111,
	"./Login/test.jsx": 111,
	"./SponsorsLandingPage": 44,
	"./SponsorsLandingPage/": 44,
	"./SponsorsLandingPage/index": 44,
	"./SponsorsLandingPage/index.jsx": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 308;
module.exports = webpackContext;